// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1GRjp","fileDisabled":"File_fileDisabled__26GS5"};